import { Box, Skeleton } from '@mui/material';
import React from 'react';

import ChatMessageBubbleSkeleton from './ChatMessageBubbleSkeleton';

const CHAT_SKELETON_BUBBLE_COUNT = 4;

const ChatSkeleton: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      px: 0,
    }}
  >
    <Box
      sx={{
        flex: 1,
        overflow: 'hidden',
        px: 2,
        py: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      {Array.from({ length: CHAT_SKELETON_BUBBLE_COUNT }, (_, i) => (
        <ChatMessageBubbleSkeleton
          key={i}
          align={i % 2 === 0 ? 'right' : 'left'}
        />
      ))}
    </Box>

    <Box
      sx={{
        p: 2,
        borderTop: 1,
        borderColor: 'divider',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Skeleton
        variant="rounded"
        height={40}
        sx={{ flex: 1, minWidth: 0, borderRadius: 1 }}
      />
      <Skeleton variant="circular" width={40} height={40} />
    </Box>
  </Box>
);

export default ChatSkeleton;
